import type { GuideContext, GuideDefinition, GuideStep } from '../engine';
import { afterCustomerResolved, afterVehicle } from './customerBranch';

function afterLeaveCustomer(ctx: GuideContext): string {
  if (ctx.stepId === 'openQuote') return 'openQuote';
  return 'service';
}

const customerSteps: GuideStep[] = [
  {
    id: 'search',
    anchor: 'wo-create.search',
    textKey: 'workOrder.search',
    onEnter: [{ type: 'navigate', to: '/workorders?new=1' }, { type: 'focus' }],
    doneWhen: 'woCreate.customerVehicleResolved',
    next: afterCustomerResolved,
  },
  {
    id: 'newVehicle',
    anchor: 'wo-create.newVehicle',
    textKey: 'fields.newVehicle',
    onEnter: [{ type: 'focus' }],
    next: afterVehicle,
  },
  {
    id: 'newPerson',
    anchor: 'wo-create.newPerson',
    textKey: 'fields.newPerson',
    onEnter: [{ type: 'focus' }],
    next: 'leaveCustomer',
  },
  {
    id: 'newCompany',
    anchor: 'wo-create.newCompany',
    textKey: 'fields.newCompany',
    onEnter: [{ type: 'focus' }],
    next: 'leaveCustomer',
  },
  {
    id: 'companyContact',
    anchor: 'wo-create.companyContact',
    textKey: 'fields.companyContact',
    onEnter: [{ type: 'focus' }],
    next: 'leaveCustomer',
  },
  {
    id: 'leaveCustomer',
    anchor: 'wo-create.next',
    textKey: 'workOrder.leaveCustomer',
    onEnter: [{ type: 'focus' }],
    doneWhen: 'woCreate.stepChanged',
    next: afterLeaveCustomer,
  },
  {
    id: 'openQuote',
    anchor: 'wo-create.openQuote',
    textKey: 'workOrder.openQuote',
    doneWhen: 'woCreate.stepChanged',
    next: 'service',
  },
];

export const workOrderCreateGuide: GuideDefinition = {
  id: 'workOrder.create',
  titleKey: 'workOrder.title',
  firstStep: 'search',
  doneTextKey: 'workOrder.done',
  steps: [
    ...customerSteps,
    {
      id: 'service',
      anchor: 'wo-create.service',
      textKey: 'workOrder.service',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.serviceAdded',
      next: 'mechanic',
    },
    {
      id: 'mechanic',
      anchor: 'wo-create.mechanic',
      textKey: 'workOrder.mechanic',
      onEnter: [{ type: 'focus' }],
      next: 'leaveServices',
    },
    {
      id: 'leaveServices',
      anchor: 'wo-create.next',
      textKey: 'workOrder.leaveServices',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.stepChanged',
      next: 'schedule',
    },
    {
      id: 'schedule',
      anchor: 'wo-create.schedule',
      textKey: 'workOrder.schedule',
      onEnter: [{ type: 'focus' }],
      next: 'leaveSchedule',
    },
    {
      id: 'leaveSchedule',
      anchor: 'wo-create.next',
      textKey: 'workOrder.leaveSchedule',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.stepChanged',
      next: 'summary',
    },
    {
      id: 'summary',
      anchor: 'wo-create.summary',
      textKey: 'workOrder.summary',
      next: 'create',
    },
    {
      id: 'create',
      anchor: 'wo-create.submit',
      textKey: 'workOrder.create',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.created',
    },
  ],
};
